// Unpublished Work © 2022 Deere & Company

export const registryLabels = {
    CONTACT_CODE: 'contactId',
    CUSTOMER_NO: 'arNumber',
    CUSTOMER_ENTITY_ID: 'entityId',
    CUSTOMER_TYPE: 'customerType'
};

export const contactNameFieldKeys = {
    PREFIX: 'prefixId',
    FIRST: 'firstName',
    FAMILIAR: 'familiarName',
    MIDDLE: 'middleName',
    LAST: 'lastName',
    GENERATION: 'generation',
    SUFFIX: 'suffix'
};

export const businessNameFieldKeys = {
    BUSINESS_NAME_ONE: 'businessName1',
    BUSINESS_NAME_TWO: 'businessName2',
    TRADING_AS: 'doingBusinessAs'
};

export const addressFieldKeys = {
    COUNTRY_CODE: 'countryCode',
    ADDRESS_LINE_1: 'addressLine1',
    ADDRESS_LINE_2: 'addressLine2',
    CITY: 'city',
    STATECODE: 'stateCode',
    POSTAL_CODE: 'postalCode',
    COUNTY_NAME: 'countyName'
};
